var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolderFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3398 12.9999H17.0898",
    stroke: "#9D9D9D",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3398 4.24988H21.4648C22.0453 4.24988 22.3356 4.24988 22.5793 4.28197C24.2621 4.5035 25.5862 5.82765 25.8077 7.5104C25.8398 7.75409 25.8398 8.04435 25.8398 8.62488",
    stroke: "#9D9D9D",
    strokeWidth: 1.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33984 9.18707C3.33984 8.0839 3.33984 7.53232 3.42653 7.07287C3.80814 5.05027 5.39023 3.46818 7.41283 3.08657C7.87228 2.99988 8.42387 2.99988 9.52703 2.99988C10.0104 2.99988 10.252 2.99988 10.4843 3.0216C11.4857 3.11524 12.4355 3.50868 13.2098 4.15052C13.3893 4.29939 13.5602 4.47029 13.902 4.81207L14.5898 5.49988C15.6096 6.5196 16.1195 7.02947 16.73 7.36917C17.0653 7.55577 17.4212 7.70313 17.7903 7.80835C18.4622 7.99988 19.1832 7.99988 20.6253 7.99988H21.0925C24.383 7.99988 26.0281 7.99988 27.0976 8.9617C27.196 9.05018 27.2896 9.1438 27.378 9.24217C28.3398 10.3116 28.3398 11.9568 28.3398 15.2473V17.9999C28.3398 22.7139 28.3398 25.071 26.8753 26.5354C25.411 27.9999 23.0538 27.9999 18.3398 27.9999H13.3398C8.62579 27.9999 6.26878 27.9999 4.80431 26.5354C3.33984 25.071 3.33984 22.7139 3.33984 17.9999V9.18707Z",
    stroke: "#9D9D9D",
    strokeWidth: 1.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderFiles);
export default __webpack_public_path__ + "static/media/icon-folder-files.1fc2ccc4e1e4a805437342401dc6488e.svg";
export { ForwardRef as ReactComponent };